import { render, staticRenderFns } from "./DocumentCategoryEdit.vue?vue&type=template&id=673cf0e4&"
import script from "./DocumentCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports